var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.78 18.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#364051;stroke-miterlimit:10;}.cls-2{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.07,3.39V15.8a2.42,2.42,0,0,0,2.42,2.42h7.89A2.42,2.42,0,0,0,14.8,15.8V3.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.28,
    y1: 3.39,
    x2: 0.5,
    y2: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.51,3.39V2.06A1.55,1.55,0,0,1,7.06.5H9.85a1.56,1.56,0,0,1,1.56,1.56V3.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.19,
    y1: 8.04,
    x2: 6.19,
    y2: 13.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.7,
    y1: 8.04,
    x2: 10.7,
    y2: 13.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.57b01553bca7044a54c49f4d5009c0b2.svg";
export { ForwardRef as ReactComponent };